<template>
	<div class="centerWidth">
		<!-- <div class="gaokao-nav">
			<span>个人中心 ></span>
			<span>专业定位测评 ></span>
			<span>开始测试</span>
		</div> -->
		<section class="gaokao-content">
			<div class="my-title">专业定位测评</div>
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<img src="../../../image/Eva-des-aa.png" />
							<span>兴趣分析</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<img src="../../../image/major-cha-aa.png" />
							<span>性格分析</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<img src="../../../image/major-abi-aa.png" />
							<span>能力分析</span>
						</div>
					</div>
				</li>
			</ul>
			<p class="test-tit">能力分析</p>
			<article class="testTwo-con">
				<div class="testTwo-list" v-for="item in list" :key="item.Id">
					<p class="test-ctxt" :class="{'empty-question': !item.notEmpty}">{{item.Sort}}/{{ list.length}}
						{{item.Title}}{{item.Remark}}
					</p>
					<template v-if="item.ImgList.length > 0">
						<div class="way-testB">
							<img :src="imgUrl" alt="" v-for="imgUrl in item.ImgList" :key="imgUrl">
						</div>
					</template>
					<template v-if="item.Type === 1">
						<ul class="testTwo-ul">
							<li v-for="answer in item.AnswerList" :key="answer.Id">
								<input type="radio" :name="'q' + item.Id" :value="answer.Option"
									v-model="item.Option" />
								<p>{{answer.Option}}.{{answer.Content}}</p>
							</li>
						</ul>
					</template>
					<template v-if="item.Type === 2">
						<ul class="testTwo-ul">
							<li v-for="answer in item.AnswerList" :key="answer.Id">
								<input type="checkbox" :name="'q' + item.Id" :value="answer.Option"
									v-model="item.OptionList" />
								<p>{{answer.Option}}.{{answer.Content}}</p>
							</li>
						</ul>
					</template>
				</div>
			</article>
			<div class="test-btn">
				<button class="gaokao-btn" @click="goNextb()">上一步</button>
				<button class="gaokao-btn" @click="subPop()">提交</button>
			</div>
		</section>
		<!-- 提交弹窗 -->
		<div class="popup" v-show="isSub">
			<div class="pop-width animated fadeIn">
				<div class="submit-bg"><img src="../../../image/pop-del.png" @click="subDel" /></div>
				<p class="submit-tit">提交成功</p>
				<p class="submit-txt">系统将自动跳转[我的报告]，跳转后点击[查看报告]</p>
				<p class="submit-txt">马上了解最适合你科目组合吧!</p>
				<button class="gaokao-btn pop-btn" @click="goReport">确定</button>
			</div>
		</div>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-if="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: () => {
					return [];
				}
			},
			isSub: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isJiaIng: false
			};
		},
		mounted() {
			this.drawLineB();
		},
		methods: {
			drawLineB() {
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: '75%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
							value: 1048,
							name: ''
						}, {
							value: 735,
							name: ''
						}]
					}]
				});
			},
			// 上一步
			goNextb() {
				this.$emit('prev');
			},
			// 我的报告
			goReport() {
				this.$router.push('/report');
			},
			// 提交
			subPop() {
				this.$emit('save');
			},
			subDel() {
				this.isSub = false;
			}
		}
	};
</script>

<style scoped>
	.test-ctxt.empty-question {
		color: #ff1e00;
		font-weight: bold;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.test-tit {
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 20px;
		margin-bottom: 30px;
	}

	.test-tit::after {
		position: absolute;
		content: '';
		width: 0;
		height: 20px;
		left: 0;
		top: 50%;
		margin-top: -10px;
		border: 2px solid #333;
		border-radius: 50px;
	}

	/* testTwo-con */
	.testTwo-con {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.testTwo-list {
		width: 100%;
		height: auto;
	}

	.test-ctxt {
		font-size: 15px;
		color: #333;
		margin-bottom: 25px;
	}

	.testTwo-ul {
		padding: 0 30px;
		height: auto;
		overflow: hidden;
	}

	.testTwo-ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.testTwo-ul li input {
		margin-right: 15px;
	}

	.testTwo-ul li p {
		font-size: 15px;
		color: #333;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}

	.gkTest-step {
		padding: 40px;
		justify-content: center;
	}

	.way-test {
		padding: 0 30px;
		height: auto;
		margin-bottom: 25px;
	}

	.way-test span {
		font-size: 14px;
		color: #333;
		margin-left: 10px;
	}
</style>
